import type { FormLayout } from '@/screens/ReportCreation/reportCreation.types';
import type { TFunction } from 'i18next';
import { SupportedLanguage } from '@store/i18n';

const SUPPORTED_FORMATS = ['pdf', 'docx', 'csv', 'png', 'jpeg', 'jpg', 'txt'];
const MAX_FILE_SIZE_BYTES = 15 * 1024 * 1024;

export const getStep4FormConfig = (
  t: TFunction,
  language: SupportedLanguage,
): FormLayout => ({
  sections: [
    {
      fields: [
        {
          id: 'supportingDocuments',
          type: 'file-uploader',
          label: t('reportCreation.step4.fields.attachDocuments', { lng: language }),
          required: false,
          acceptedFormats: SUPPORTED_FORMATS,
          maxFileSizeInBytes: MAX_FILE_SIZE_BYTES,
          multiple: true,
          uploadPrompt: t('reportCreation.step4.helpers.tapToAddFile', { lng: language }),
          helperText: t('reportCreation.step4.helpers.fileFormats', { lng: language }),
        },
      ],
    },
  ],
});
